let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gGEZv")).then(() => parcelRequire('1Mvyi'));